var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{attrs:{"title":_vm.$t('trade.amount')}},[_c('p',{staticClass:"total-money"},[_vm._v("\n    "+_vm._s(_vm.isHK ? 'HK$' : '')+" "+_vm._s(_vm._f("floatNum")(_vm.totalMoney,_vm.stock))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }